import * as React from 'react';
export const googlepaySvg = React.forwardRef(function googlepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.468 8.053v1.851H6.88v-4.57h1.558c.394 0 .73.131 1.006.394.281.263.422.584.422.964 0 .388-.14.71-.422.97-.272.26-.609.388-1.006.388h-.97v.003Zm0-2.157V7.49h.982c.232 0 .428-.08.581-.235a.77.77 0 0 0 .236-.56.762.762 0 0 0-.236-.554.762.762 0 0 0-.581-.242h-.982v-.003Zm3.934.777c.434 0 .777.117 1.028.35.25.232.376.55.376.954v1.927h-.56v-.435h-.024c-.242.358-.566.536-.97.536-.346 0-.633-.101-.866-.306a.977.977 0 0 1-.348-.765.92.92 0 0 1 .367-.77c.244-.194.572-.288.979-.288.348 0 .636.064.86.192v-.134a.666.666 0 0 0-.242-.52.83.83 0 0 0-.57-.215.892.892 0 0 0-.776.417l-.517-.325c.284-.413.706-.618 1.263-.618Zm-.759 2.27c0 .153.065.282.196.383a.72.72 0 0 0 .456.153.932.932 0 0 0 .66-.276.864.864 0 0 0 .291-.645c-.183-.144-.437-.217-.764-.217-.24 0-.438.058-.597.17-.162.12-.242.264-.242.432ZM16 6.774l-1.958 4.504h-.606l.729-1.576-1.291-2.928h.639l.93 2.246h.012l.906-2.246H16ZM5.131 7.68a3.07 3.07 0 0 0-.049-.551H2.62v1.01h1.418a1.215 1.215 0 0 1-.526.813v.655h.844c.493-.456.775-1.13.775-1.927Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M3.512 8.952a1.577 1.577 0 0 1-.891.251c-.684 0-1.264-.46-1.472-1.082H.28v.676a2.621 2.621 0 0 0 2.34 1.443c.708 0 1.303-.233 1.735-.633l-.844-.655Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.067 7.62c0-.174.03-.343.082-.501v-.676H.28A2.607 2.607 0 0 0 0 7.62c0 .424.1.823.279 1.177l.87-.675a1.58 1.58 0 0 1-.082-.502Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2.621 6.037c.386 0 .732.133 1.006.393l.748-.747A2.518 2.518 0 0 0 2.62 5 2.621 2.621 0 0 0 .279 6.443l.87.676c.208-.621.788-1.082 1.472-1.082Z',
    }),
  );
});
googlepaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var googlepay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'googlepay',
  svg: googlepaySvg,
};
